<section class="ftco-section p-5 d-flex flex-column">
    <a href="/"><img [src]="logo" alt="logo" style="width: 100px;"></a>
    <div class="d-flex flex-column justify-content-center align-items-center">
        <h5 class="mt-5">Forgot Password</h5>
        <div class="w-50">
            <form action="#" class="signin-form">
                <div class="form-group mb-3">
                    <input type="email" class="form-control" placeholder="Email" [(ngModel)]="email" required>
                </div>

                <div class="form-group row">
                    <div class="col-md-4"></div>
                    <button type="submit" class="col-md-4 submit px-3 w-fit-content" [style]="style.btnstyle" [disabled]="!email"
                        (click)="recoverPassword()">Recover Password</button>
                    <div class="col-md-4"></div>
                </div>
            </form>
        </div>
    </div>
</section>